import {Paper, Stack} from "@mui/material";
import {useSearch} from "@tanstack/react-router";
import {useEffect} from "react";
import ReactMarkdown from "react-markdown";
import RegisterGuestForm from "@/components/Forms/RegisterGuestForm.tsx";
import CompleteFeeCard from "@/components/Home/CompleteFeeCard.tsx";
import MainDisplayContainer from "@/components/Layout/MainDisplayContainer.tsx";
import {LoggedOutHeader} from "@/components/Navigation/LoggedOutHeader.tsx";
import {useLoggedOutFee} from "@/components/Providers/LoggedOutFeeProvider.tsx";
import NoticeProvider, {useNotice} from "@/components/Providers/NoticeProvider";

const RegisterGuest = () => {
    const [notice] = useNotice();
    const search = useSearch({strict: false});
    const {setFeeId} = useLoggedOutFee();
    useEffect(() => {
        if ("feeId" in search && typeof search.feeId === "string") {
            setFeeId(search.feeId);
        }
    }, [search]);

    return (
        <NoticeProvider>
            <LoggedOutHeader mode={"instructor"} />
            <MainDisplayContainer>
                <Stack
                    sx={{
                        px: {lg: 2},
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <Paper
                        elevation={3}
                        sx={{
                            maxWidth: "500px",
                            p: 2,
                        }}
                    >
                        <ReactMarkdown className="markdown">
                            {notice.guestLogInMessage}
                        </ReactMarkdown>
                        <CompleteFeeCard />
                        <RegisterGuestForm />
                    </Paper>
                </Stack>
            </MainDisplayContainer>
        </NoticeProvider>
    );
};

export default RegisterGuest;
